import "./index.less";
import { setCookie, cookie }  from '@utils/index.js'
import { regoinlist } from '@utils/api.js';

const initLocaleSwitcherComponent = () => {
    if (!customElements.get('jky-locale-switcher')) { 
        customElements.define('jky-locale-switcher', class JkyLocaleSwitcher extends HTMLElement {
            constructor() {
                super();
                this.regoinList = window.regoinList;
                this.handleDocumentClick = this.handleDocumentClick.bind(this);

                if (typeof loadCSS !== 'undefined' && typeof pageInfo !== 'undefined') {
                    loadCSS(pageInfo.__webpack_public_path__ + 'plugins-locale-switcher.min.css', () => {
                        this.classList.remove("hidden");
                    });
                } else {
                    this.classList.remove("hidden");
                }
            }

            connectedCallback() {
                const flag = window.localStorage.getItem("closeLocaleSwitcher");
                const localeCookie = cookie.get('_jk_locale_switcher')
                if (flag == '1' || localeCookie) {
                    return false;
                }
                this.showEuRemind = false;
                this.selectors = {
                    locale_switcher: this.querySelector('.locale-switcher'),
                    locale_switcher_text: this.querySelector('.locale-switcher .locale-switcher--text'),
                    locale_switcher_val: this.querySelector('.locale-switcher .locale-switcher--value .text'),
                    locale_switcher_btn: this.querySelector('.locale-switcher .locale-switcher--button'),
                    locale_switcher_close: this.querySelector(".locale-switcher .locale-switcher--close"),
                    locale_switcher_ul: this.querySelector(".locale-switcher .locale-switcher--ul"),
                    locale_switcher_sel: this.querySelector(".locale-switcher .locale-switcher--selected"),
                    locale_switcher_current: this.querySelector(".locale-switcher .locale-switcher--selected .current"),
                };
                this.init();
            }

            disconnectedCallback() {
                document.removeEventListener('click', this.handleDocumentClick);
            }

            async initLocaleSwitcher() {
                const params = {
                    // ip: '35.157.96.82'
                }
                try {
                    const { data } = await regoinlist(params);
                    this.regoinList = data;
                } catch (error) {
                    console.error('Failed to fetch region list:', error);
                    return;
                }

                const { showFlag, regoinResps, currentIpRegoin, showEuRemind } = this.regoinList;
                if (!showFlag) return;
                this.showEuRemind = showEuRemind;
                
                if (this.selectors.locale_switcher_text) {
                    this.selectors.locale_switcher_text.innerHTML = currentIpRegoin.showInfo;
                }
                if (this.selectors.locale_switcher_val) {
                    this.selectors.locale_switcher_val.innerHTML = currentIpRegoin.name;
                    this.selectors.locale_switcher_val.setAttribute('value', currentIpRegoin.shopId);
                }
                if (this.selectors.locale_switcher_btn) {
                    this.selectors.locale_switcher_btn.textContent = currentIpRegoin.showButton;
                }
                if (this.selectors.locale_switcher) {
                    this.selectors.locale_switcher.classList.add('locale-switcher-show');
                    // 如果是EU，在满足条件的情况下显示EU提醒弹窗
                    if (this.showEuRemind) {
                        this.showEuModal();
                    }
                }
                
                const filterData = regoinResps.filter(item => item.shopId !== currentIpRegoin.shopId);
                
                const currentHtml = `
                <svg class="icon-arrowtop" viewBox="0 0 1024 1024" width="16" height="16" style="margin:0 auto;display:block;fill:currentColor;"><path d="M512 320L192 704h640z"></path></svg>
                <li class="current" data-url="${currentIpRegoin.domain}" value="${currentIpRegoin.shopId}">
                    <span>
                        <span class="icon"> 
                            <svg viewBox="0 0 1024 1024" width="14" height="14" style="fill:currentColor;"><path d="M384 853.333l-341.333-341.333 90.453-90.453 250.88 250.88 549.547-549.547 90.453 90.453z"></path></svg>
                        </span> 
                        <span> ${currentIpRegoin.name}</span>
                    </span>
                    <span></span>
                </li>
                `;

                const listHtml = filterData.map(item => `
                    <li class="sel-li" data-url="${item.domain}" data-value="${item.shopId}">
                        <span>
                            <span class="icon"></span> 
                            <span class="text">${item.name}</span>
                        </span>
                        <span></span>
                    </li>
                `).join('');

                if (this.selectors.locale_switcher_ul) {
                    this.selectors.locale_switcher_ul.innerHTML = currentHtml + listHtml;
                }
            }

            handleDocumentClick(e) {
                const localePops = document.querySelectorAll(".locale-switcher--ul");
                const isTargetMatched = e.target.closest('.local-switcher--selected, .locale-switcher--selected, .icon-arrowdown, .icon, .text');
                
                localePops.forEach(localePop => {
                    if (!localePop.contains(e.target) && !isTargetMatched) {
                        localePop.classList.remove("show");
                    }
                });
            }

            onLocaleSwitcher() {
                if (this.selectors.locale_switcher_sel) {
                    this.selectors.locale_switcher_sel.addEventListener('click', () => {
                        if (this.selectors.locale_switcher_ul) {
                            this.selectors.locale_switcher_ul.classList.add('show');
                        }
                    });
                }

                // 跳转点击
                if (this.selectors.locale_switcher_btn) {
                    this.selectors.locale_switcher_btn.addEventListener('click', () => {
                        setCookie('_jk_locale_switcher', 'true', 180, true);
                        if (this.regoinList?.currentIpRegoin?.domain) {
                            window.location.href = this.regoinList.currentIpRegoin.domain;
                        }
                    });
                }
                
                if (this.selectors.locale_switcher_ul) {
                    this.selectors.locale_switcher_ul.addEventListener('mouseleave', () => {
                        this.selectors.locale_switcher_ul.classList.remove('show');
                    });
                }

                document.addEventListener('click', this.handleDocumentClick);

                if (this.selectors.locale_switcher_ul) {
                    this.selectors.locale_switcher_ul.addEventListener("click", (e) => {
                        const li = e.target.closest('li');
                        if (li) {
                            const domain = li.getAttribute("data-url");
                            setCookie('_jk_locale_switcher', 'true', 180, true);
                            if (domain) {
                                window.location.href = domain;
                            }
                        }
                    });
                }
            }

            closeLocaleSwitcher() {
                if (this.selectors.locale_switcher_close) {
                    this.selectors.locale_switcher_close.addEventListener('click', () => {
                        if (this.selectors.locale_switcher) {
                            const el = this.selectors.locale_switcher;
                            el.style.transition = 'all 0.25s ease';
                            el.style.overflow = 'hidden';
                            el.style.height = el.offsetHeight + 'px';
                            
                            requestAnimationFrame(() => {
                                el.style.height = '0px';
                                el.style.paddingTop = '0px';
                                el.style.paddingBottom = '0px';
                                el.style.opacity = '0';
                            });
                            
                            setTimeout(() => {
                                el.style.display = 'none';
                            }, 250);
                        }
                        window.localStorage.setItem("closeLocaleSwitcher", "1");
                    });
                }
            }

            showEuModal(options = {}) {
                const existing = document.getElementById('jky-locale-switcher-eu-modal');
                if (existing) {
                    existing.setAttribute('open', true);
                    return;
                }

                const currentIpRegoin = this?.regoinList?.currentIpRegoin || {};
                let targetDomain = options.targetDomain || currentIpRegoin.domain;
                const title = options.showLocation || currentIpRegoin.showLocation || '';
                const confirmText = options.confirmText || currentIpRegoin.showButton;
                const cancelText = options.cancelText || currentIpRegoin.showCancel;

                const dialog = document.createElement('jds-dialog');
                dialog.id = 'jky-locale-switcher-eu-modal';
                dialog.style = '--jds-dialog-index:100002;--jds-dialog-width:32rem;';
                dialog.innerHTML = `
                    <div class="jds-rte mt-4">
                        <div class="text-[#242F20] mb-10 text-base lg:text-xl">${title}</div>
                        <div class="flex justify-center gap-8">
                            <jds-button data-action="cancel" variant="secondary" kind="custom" style="--jds-btn-custom-color:#242F20;">${cancelText}</jds-button>
                            <jds-button data-action="confirm" kind="custom" style="--jds-btn-custom-color:#242F20;">${confirmText}</jds-button>
                        </div>
                    </div>
                `;
                
                dialog.addEventListener('jds-dialog-close', () => {
                    setCookie('_jk_locale_switcher', 'true', 180, true);
                    dialog.remove();
                    document.body.style.overflow = 'auto';
                });

                dialog.addEventListener('click', (e) => {
                    const btn = e.target.closest('jds-button');
                    const action = btn?.dataset?.action;
                    setCookie('_jk_locale_switcher', 'true', 180, true);
                    if (!action) return;
                    if (action === 'cancel') {
                        dialog.remove();
                        document.body.style.overflow = 'auto';
                        return;
                    }
                    if (action === 'confirm') {
                        if (targetDomain) window.location.href = targetDomain;
                    }
                });

                document.body.appendChild(dialog);
                dialog.setAttribute('open', true);
            }

            init () {
                this.initLocaleSwitcher();
                this.onLocaleSwitcher();
                this.closeLocaleSwitcher();
            }
        });
    }
};

if (document.readyState !== 'loading') {
    initLocaleSwitcherComponent();
} else {
    document.addEventListener('DOMContentLoaded', initLocaleSwitcherComponent);
}
